<template>
  <a-row type="flex" :gutter="[8, 8]">
    <a-col :span="24" :xl="18">
      <a-card style="height: 100%">
        <a-row :gutter="[8, 8]" align="middle">
          <a-col :span="24">
            <a-row align="middle" justify="space-between" :gutter="[8, 8]">
              <a-col>
                <a-typography-title :level="4" class="text-gray-8 mb-0">
                  {{ title }}
                </a-typography-title>
              </a-col>
              <a-col>
                <a-row :gutter="[8, 8]">
                  <a-col>
                    <a-button
                      :type="
                        showing_type === 'percentage' ? 'primary' : 'default'
                      "
                      @click="changeShowingType('percentage')"
                    >
                      Porcentajes
                    </a-button>
                  </a-col>
                  <a-col>
                    <a-button
                      :type="showing_type === 'number' ? 'primary' : 'default'"
                      @click="changeShowingType('number')"
                    >
                      Números
                    </a-button>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="24">
            <a-row justify="space-between" align="middle" :gutter="[8, 8]">
              <card
                :xs="12"
                :md="24"
                v-for="(cat, index) in categoryValues"
                :key="cat.name"
                :title="cat.name"
                :total="
                  showing_type === 'number'
                    ? cat.first_display
                    : cat.second_display
                "
                :showSeparator="index != categoryValues.length - 1"
                :length="categoryValues.length"
                :index="index"
              />
            </a-row>
          </a-col>
        </a-row>
      </a-card>
    </a-col>
    <a-col :span="24" :xl="6">
      <progress-bar :value="totalProgress" />
    </a-col>
  </a-row>
</template>

<script>
import { ref } from 'vue';
import ResumeHeaderCard from './resume-header-card.vue';
import ResumeHeaderProgressBar from './resume-header-progress-bar.vue';

export default {
  props: {
    title: {
      type: String,
      default: 'Resumen total'
    },
    categoryValues: {
      type: Object,
      default: []
    },
    totalProgress: {
      type: Number,
      default: 0
    }
  },
  components: {
    card: ResumeHeaderCard,
    'progress-bar': ResumeHeaderProgressBar
  },
  setup() {
    const showing_type = ref('number');

    const changeShowingType = (type) => {
      showing_type.value = type;
    };

    return {
      showing_type,
      changeShowingType
    };
  }
};
</script>
